import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ListaScrollingComponent } from './lista-scrolling.component';
import {ScrollingModule} from '@angular/cdk/scrolling';
import { MatCardModule } from '@angular/material/card';
import { PullReloadingModule } from '../pull-reloading/pull-reloading.module';
import { MatListModule} from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { HammerGestureConfig, HAMMER_GESTURE_CONFIG } from '@angular/platform-browser';
import { MatRippleModule } from '@angular/material/core';


@NgModule({
  declarations: [ListaScrollingComponent],
  imports: [
    CommonModule,
    ScrollingModule,
    MatCardModule,    
    PullReloadingModule,
    MatListModule,
    MatIconModule,
    MatRippleModule
  ],
  exports: [ListaScrollingComponent]
})
export class ListaScrollingModule { }
